import { ListUserPortalsRequest, ListUserPortalsResponse } from '@eigtech/delegate-types'
import { queryClient } from '@/store'
import { queryOptions, useQuery } from '@eigtech/ui-shared-api'
import { useAuth0 } from '@eigtech/ui-shared-auth'
import { delegateBasePath } from '../constants'
import { get } from '../instance'
import { portalsQueryKeys } from './constants'

const getPortals = async ({ auth0Id, email }: ListUserPortalsRequest) => {
  const { portals } = await get<ListUserPortalsResponse>(
    `${delegateBasePath}/user/${auth0Id}/${email}/portals`
  )

  return portals
}

export const getPortalsQueryOptions = (request: ListUserPortalsRequest) =>
  queryOptions({
    queryKey: portalsQueryKeys.list(),
    queryFn: () => getPortals(request),
  })

const getActivePortals = async (request: ListUserPortalsRequest) => {
  const portals = await queryClient.fetchQuery(getPortalsQueryOptions(request))

  return portals.filter((portal) => portal.status === 'ACTIVE')
}

export const getActivePortalsQueryOptions = (request: ListUserPortalsRequest) =>
  queryOptions({
    queryKey: portalsQueryKeys.listActive(),
    queryFn: () => getActivePortals(request),
  })

export function useGetActivePortals() {
  const { user } = useAuth0()

  const auth0Id = user?.sub ?? ''
  const email = user?.email ?? ''

  return useQuery(getActivePortalsQueryOptions({ auth0Id, email }))
}

export function useGetPortals() {
  const { user } = useAuth0()

  const auth0Id = user?.sub ?? ''
  const email = user?.email ?? ''

  return useQuery(getPortalsQueryOptions({ auth0Id, email }))
}
